import { ListItem, StyledComponentProps, Divider } from '@material-ui/core';
import * as React from 'react';
import { access } from '../../../model/access';
import { AccessInfo } from './AccessInfo';

interface IProps extends StyledComponentProps {
    // doneReminder: (reminder: access, done: boolean) => void;
    // onReminderClick: (_id: string) => void;
    access: access;
    isSelected: boolean;
    showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}
interface IState {
    // open: boolean;
    // reminder: reminder;
    // openRoom: boolean;
}


export class AccessItem extends React.Component<IProps, IState> {
    // state = { open: false } //, reminder: this.props.reminder }

    setSelected = (_done: boolean) => {
        // this.props.doneReminder(this.props.reminder, _done);
        // console.log("REMINDERRRRRRRRRRRRRRRRRRR SET SELECTED :" + _done); // JSON.stringify(this.state.reminder));
    }

    // private expandTags = (evt: React.MouseEvent<SVGSVGElement, MouseEvent>, open: boolean, openRoom: boolean) => {
    //     this.setState({
    //         open: open,
    //         // openRoom: open
    //     });
    //     evt.stopPropagation();
    // }

    render() {
        const { access, classes } = this.props;
        return (
            <>
                <ListItem>
                    <AccessInfo access={access} 
                        classes={classes} 
                        // clickItem={this.props.onReminderClick} 
                        // setSelected={this.setSelected} 
                        showContactInfo={this.props.showContactInfo ?? true} />
                </ListItem>
                <Divider />
            </>
        );
    }
}